const isNonEmptyString = (value: unknown): value is string => typeof value === "string" && value.length > 0;

/**
 * Stable subject for assumed-user storage ownership across auth modes.
 * Headless access tokens may use email for `sub` while interactive Okta id tokens use the Okta user id.
 */
export function resolveAuthenticatedUserSub(claims: Record<string, unknown> | null | undefined): string {
  if (isNonEmptyString(claims?.uid)) return claims.uid;
  if (isNonEmptyString(claims?.sub)) return claims.sub;

  return "token-user";
}
